import gql from 'graphql-tag';

export const SEARCH_EQUIPMENTS = gql`
  query searchEquipments ($idValue: String!) {
    SearchEquipments(name:$idValue) {
      id,
      name
    }
  }
`;


export const GET_EQUIPMENT = gql`
  query getEquipment(
    $id: ID,
    $type: String,
    $name: String
  ) {
  Equipment(
    id: $id,
    type: $type,
    name: $name
  ) {
    id,
    type,
    name,
    maker {
      id,
      fullName,
      __typename
    }
    usedIn {
      id,
      title,
      __typename
    },
    contributedBy {
      id,
      contributor {
        id,
        fullName,
        __typename
      }
      role,
      isCredited,
      creditText,
      featured
    }
  }
}
`;

export const CREATE_EQUIPMENT = gql`
  mutation ceateEquipment(
    $id: ID,
    $type: String,
    $name: String
  ) {
  CreateEquipment(
    id: $id,
    type: $type,
    name: $name
  ) {
    id,
    type,
    name
  }
}
`;

export const UPDATE_EQUIPMENT = gql`
  mutation updateEquipment(
    $id: ID!,
    $type: String,
    $name: String
  ) {
  UpdateEquipment(
    id: $id,
    type: $type,
    name: $name
  ) {
    id,
    type,
    name
  }
}
`;

export const DELETE_EQUIPMENT = gql`
  mutation deleteEquipment (
    $id: ID!
  ) {
  DeleteEquipment(
    id: $id
  ) {
    id
  }
}
`;

// AddEquipmentContributedBy(
//   from: _ContributionInput!
//   to: _EquipmentInput!
// ): _AddEquipmentContributedByPayload
// RemoveEquipmentContributedBy(
//   from: _ContributionInput!
//   to: _EquipmentInput!
// ): _RemoveEquipmentContributedByPayload
